/* import __COLOCATED_TEMPLATE__ from './sms.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PHONE_DELIVERY_METHODS } from './base';
let TwoFactorEnrollSmsComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _class = class TwoFactorEnrollSmsComponent extends Component {
  get invalidPhoneErrorTLabel() {
    return 'generic_errors.phone.invalid';
  }
  get unknownErrorTLabel() {
    return 'generic_errors.other.unknown';
  }
  get lockoutErrorTLabel() {
    return 'generic_errors.other.lockout';
  }
  get privacyPolicyUrl() {
    return this.multipassfeClient.constants.PRIVACY_POLICY_URL;
  }
  get termsAndConditionsUrl() {
    return this.multipassfeClient.constants.TERMS_AND_CONDITIONS_URL;
  }
  get canRequestSignInCode() {
    return this.phoneNumberValid;
  }
  get countryCodeToT() {
    const tKeyPrefix = this.args.tPrefix + 'phone_number.country_code.';
    const map = {};
    this.multipassfeClient.constants.COUNTRY_CODES.SMS.forEach(c => map[c] = tKeyPrefix + c);
    return map;
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "logger", _descriptor2, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor3, this);
    _defineProperty(this, "phoneDeliveryMethods", PHONE_DELIVERY_METHODS);
    _initializerDefineProperty(this, "countrySupportsVoice", _descriptor4, this);
    _initializerDefineProperty(this, "loading", _descriptor5, this);
    _initializerDefineProperty(this, "phoneError", _descriptor6, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor7, this);
    _initializerDefineProperty(this, "phoneNumberValid", _descriptor8, this);
    _initializerDefineProperty(this, "smsBlockedManualOptInModalOpen", _descriptor9, this);
    _defineProperty(this, "validating", false);
  }
  handleMultipassError(error) {
    switch (error.message) {
      case 'BLOCKED_SMS_NUMBER':
        this.smsBlockedManualOptInModalOpen = true;
        break;
      case 'INVALID_ALIAS':
        this.phoneError = this.intl.t(this.args.tPrefix + this.invalidPhoneErrorTLabel);
        break;
      case 'TEMPORARY_LOCKOUT':
        this.phoneError = this.intl.t(this.args.tPrefix + this.lockoutErrorTLabel);
        break;
      default:
        this.logger.sentryError(error);
        this.phoneError = this.intl.t(this.args.tPrefix + this.unknownErrorTLabel);
    }
  }
  handleSmsBlockedManualOptInModalClose() {
    this.smsBlockedManualOptInModalOpen = false;
  }
  onCountryCodeSelected(countryCode) {
    this.countrySupportsVoice = this.multipassfeClient.constants.COUNTRY_CODES.VOICE.includes(countryCode);
    if (!this.countrySupportsVoice) {
      this.args.setSelectedPhoneDeliveryMethod(this.phoneDeliveryMethods.SMS);
    }
  }
  onPhoneDeliveryMethodChange(event) {
    if (event.detail.newSelectionValue) {
      this.args.setSelectedPhoneDeliveryMethod(event.detail.newSelectionValue);
    }
  }
  onPhoneInvalid() {
    this.phoneNumber = '';
    this.phoneNumberValid = false;
  }
  onPhoneValid({
    number,
    national
  }) {
    this.phoneNumber = number;
    this.phoneNumberValid = true;
    this.args.setPhoneNumber(this.phoneNumber);
    this.args.setPhoneNumberDisplay(national);
  }
  async sendSmsTwoFactorCodeDebounced() {
    debounce(this, this.sendSmsTwoFactorCode, 500, true);
  }
  async sendSmsTwoFactorCode() {
    this.phoneSubmitted = true;
    if (!this.canRequestSignInCode) {
      this.phoneError = this.intl.t(this.args.tPrefix + this.invalidPhoneErrorTLabel);
      return;
    }
    try {
      this.validating = true;
      this.loading = true;
      if (this.args.selectedPhoneDeliveryMethod === this.phoneDeliveryMethods.VOICE) {
        await this.multipassfeClient.enrollTwoFactorVoice(this.phoneNumber);
      } else {
        await this.multipassfeClient.enrollTwoFactorSms(this.phoneNumber);
      }
      this.args.next();
    } catch (e) {
      this.handleMultipassError(e);
    } finally {
      this.loading = false;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "countrySupportsVoice", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "phoneError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberValid", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "smsBlockedManualOptInModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleSmsBlockedManualOptInModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSmsBlockedManualOptInModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCountryCodeSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCountryCodeSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPhoneDeliveryMethodChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPhoneDeliveryMethodChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPhoneInvalid", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPhoneInvalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPhoneValid", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPhoneValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendSmsTwoFactorCodeDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendSmsTwoFactorCodeDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendSmsTwoFactorCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendSmsTwoFactorCode"), _class.prototype), _class);
export { TwoFactorEnrollSmsComponent as default };